import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const headers = { 'Content-Type': 'application/json' };

const handle = (err) => {
    if (err.response?.data) throw err.response.data;
    throw err;
};

// GET the cost centers this user can raise a scrap sale for
export const getScrapCostCenterCodes = async (UID, RID) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetScrapCostCenterCodes?UID=${encodeURIComponent(UID)}&RID=${encodeURIComponent(RID)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the (static, CC-independent) scrap item categories
export const getScrapCategories = async () => {
    try {
        const res = await axios.get(`${API_BASE_URL}/Purchase/Getscrapcategories`, { headers });
        return res.data;
    } catch (err) { handle(err); }
};

// GET item codes available for scrap sale, scoped to a category + cost center
export const getScrapItemCodes = async (Cat, CCCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetScrapItemCodes?Cat=${encodeURIComponent(Cat)}&CCCode=${encodeURIComponent(CCCode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — stage one item into the scrap-sale grid for the cost center
// payload: { ScrapListId, Costcenter }
export const saveScrapItems = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveScrapItems`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the staged scrap-sale grid for a cost center
export const viewScrapDetails = async (CCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/ViewScrapDetails?CCode=${encodeURIComponent(CCode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — remove a staged item
// payload: { ScrapListId }
export const deleteScrapItem = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/DeleteScrapItem`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET the earliest allowed scrap-sale date for a cost center (enforced as the date
// picker's minDate, mirroring the legacy page's datepicker "minDate" option)
export const getScrapSaleDate = async (CCCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Purchase/GetScrapsaledate?CCCode=${encodeURIComponent(CCCode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// POST — finalize the scrap sale for every staged item
// payload: { ScrapListIds, Basics, Quantitys, Amounts, TotalAmount, Costcenter, SaleDate,
//            Remarks, ClientName, SubclientName, RoleID, Createdby }
export const saveScrapSale = async (payload) => {
    try {
        const res = await axios.post(
            `${API_BASE_URL}/Purchase/SaveScrapSale`,
            payload,
            { headers, timeout: 30000 }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET clients raising POs against this cost center (shared Accounts endpoint —
// ClientCode is the plain code, used directly as the ClientName save param)
export const getClientByCostCenter = async (InvType, CcCode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Accounts/GetClientbyCostCenter?InvType=${InvType == null ? '' : encodeURIComponent(InvType)}&CcCode=${encodeURIComponent(CcCode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};

// GET sub-clients for a client at a cost center. SubClientCode comes back as
// "CODE , Branch Name" — the real code (not SubClientId) is what the save SP expects.
export const getSubClientsByClient = async (InvType, CcCode, Clientcode) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/Accounts/GetSubClientsbyClient?InvType=${InvType == null ? '' : encodeURIComponent(InvType)}&CcCode=${encodeURIComponent(CcCode)}&Clientcode=${encodeURIComponent(Clientcode)}`,
            { headers }
        );
        return res.data;
    } catch (err) { handle(err); }
};
